// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2IfkG","filesListContainer":"PosDisputesFiles_filesListContainer__1PsR3","filesButton":"PosDisputesFiles_filesButton__1ilK5"};